export default __webpack_public_path__ + "static/media/panierMoinsDisabled.1eb3fb55.svg";